import React, { useEffect, useState } from "react";
import AdminHeader from "../../components/header";
import AdminSidebar from "../../components/sidebar";
import styles from "../../styles/admin.module.css";
import TableView from "../../components/table_view";
import {
  faTrash,
  faEye,
  faBan,
  faCheck,
  faArchive,
  faUsers,
  faUserCheck,
  faUserPlus,
  faUserLock,
  faBoxArchive,
  faClock,
  faUserTie,
} from "@fortawesome/free-solid-svg-icons";
import axiosInstance from "../../../AxiosInstance";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DeleteModal from "../../components/delete_modal/delete_modal";
import { formatTimestamp } from "../../components/utils";
import {
  toast,
  ToastTypes,
} from "../../../components/ajonjolib/toasts/toast/toast";
import { Link } from "react-router-dom";
import Table from "../../components/table/index";

// Composant pour une carte de KPI
const KpiCard = ({ title, value, icon, color }) => (
  <div className="col-xl-4 col-md-6 mb-4">
    <div
      className={`card border-start-4 border-start-${color} shadow h-100 py-2`}
    >
      <div className="card-body">
        <div className="row no-gutters align-items-center">
          <div className="col me-2">
            <div
              className={`text-xs fw-bold text-${color} text-uppercase mb-1`}
            >
              {title}
            </div>
            <div className="h5 mb-0 fw-bold text-gray-800">{value}</div>
          </div>
          <div className="col-auto">
            <FontAwesomeIcon icon={icon} size="2x" className="text-gray-300" />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default function ClientList() {
  const [rows, setRows] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [actionLoading, setActionLoading] = useState({});
  const [stats, setStats] = useState(null);

  useEffect(() => {
    // Charger les statistiques des clients
    axiosInstance.get("clients/stats/").then((response) => {
      setStats(response.data);
    });
  }, []);

  const deleteObj = (id) => {
    axiosInstance.delete("clients/" + id + "/").then((response) => {
      window.location.reload();
    });
  };

  const handleBlockUser = (id) => {
    setActionLoading((prev) => ({ ...prev, [id]: true }));
    axiosInstance
      .post(`clients/${id}/block_user/`, {
        reason: "Bloqué par l'administrateur",
      })
      .then((response) => {
        if (response.status === 200) {
          toast("Utilisateur bloqué avec succès", ToastTypes.SUCCESS);
          setRows((prevRows) =>
            prevRows.map((row) =>
              row.id === id ? { ...row, is_blocked: true } : row
            )
          );
        }
      })
      .catch((error) => {
        toast("Erreur lors du blocage de l'utilisateur", ToastTypes.ERROR);
      })
      .finally(() => {
        setActionLoading((prev) => ({ ...prev, [id]: false }));
      });
  };

  const handleUnblockUser = (id) => {
    setActionLoading((prev) => ({ ...prev, [id]: true }));
    axiosInstance
      .post(`clients/${id}/unblock_user/`)
      .then((response) => {
        if (response.status === 200) {
          toast("Utilisateur débloqué avec succès", ToastTypes.SUCCESS);
          setRows((prevRows) =>
            prevRows.map((row) =>
              row.id === id ? { ...row, is_blocked: false } : row
            )
          );
        }
      })
      .catch((error) => {
        toast("Erreur lors du déblocage de l'utilisateur", ToastTypes.ERROR);
      })
      .finally(() => {
        setActionLoading((prev) => ({ ...prev, [id]: false }));
      });
  };

  const handleArchiveUser = (id) => {
    setActionLoading((prev) => ({ ...prev, [id]: true }));
    axiosInstance
      .post(`clients/${id}/archive_user/`, {
        reason: "Archivé par l'administrateur",
      })
      .then((response) => {
        if (response.status === 200) {
          toast("Utilisateur archivé avec succès", ToastTypes.SUCCESS);
          setRows((prevRows) =>
            prevRows.map((row) =>
              row.id === id ? { ...row, is_archived: true } : row
            )
          );
        }
      })
      .catch((error) => {
        toast("Erreur lors de l'archivage de l'utilisateur", ToastTypes.ERROR);
      })
      .finally(() => {
        setActionLoading((prev) => ({ ...prev, [id]: false }));
      });
  };

  const cols = [
    {
      title: "Full Name",
      internal: "name",
      filter: true,
      filterInternal: "name",
      filterable: true,
      sortable: true,
      sortField: "name",
      code: (row, data) => {
        return <span>{row?.name + " " + row?.lastname}</span>;
      },
    },
    {
      title: "Email",
      internal: "email",
      filter: true,
      filterInternal: "email",
      // sortable: true,
      // filterable: true,
      // sortField: "email",
    },
    {
      title: "Phone Number",
      internal: "phone_number",
      filter: true,
      filterInternal: "phone_number",
      sortable: true,
      filterable: true,
      sortField: "phone_number",
    },
    {
      title: "Status",
      internal: "status",
      code: (row, data) => {
        if (row?.is_archived) {
          return <span className="badge bg-secondary">Archivé</span>;
        } else if (row?.is_blocked) {
          return <span className="badge bg-danger">Bloqué</span>;
        } else {
          return <span className="badge bg-primary">Actif</span>;
        }
      },
    },
    {
      title: "Orders",
      internal: "user_sales",
      filter: true,
      filterInternal: "user_sales",
      // sortable: true,
      // sortField: "user_sales",
      // filterable: true,
      code: (row, data) => {
        return <span>{row?.user_sales || 0}</span>;
      },
    },
    {
      title: "Last Order",
      internal: "last_order_timestamp",
      filter: true,
      dateFilter: true,
      filterInternal: "last_order_timestamp",
      sortable: true,
      sortField: "last_order_timestamp",
      code: (row, data) =>
        data ? formatTimestamp(new Date(data)) : "No orders yet",
    },
    {
      title: "Last Login",
      internal: "last_login",
      filter: true,
      dateFilter: true,
      filterInternal: "last_login",
      sortable: true,
      sortField: "last_login",
      code: (row, data) =>
        data ? formatTimestamp(new Date(data)) : "Jamais connecté",
    },
    {
      title: "Date Created",
      internal: "date_joined",
      filter: true,
      dateFilter: true,
      filterInternal: "date_joined",
      sortable: true,
      sortField: "date_joined",
      code: (row, data) => (data ? formatTimestamp(new Date(data)) : "N/A"),
    },
    {
      title: "Actions",
      internal: "id",
      code: (row, data) => {
        return (
          <div className={"d-flex justify-content-end gap-2"}>
            <Link
              to={"/admin/clients/detail/" + row?.id}
              style={{ cursor: "pointer" }}
            >
              <FontAwesomeIcon icon={faEye} color={"#007bff"} />
            </Link>

            {/* {!row?.is_blocked && !row?.is_archived && (
              <div
                style={{ cursor: "pointer" }}
                onClick={() => handleBlockUser(row?.id)}
                title="Bloquer l'utilisateur"
              >
                <FontAwesomeIcon icon={faBan} color={"#dc3545"} />
              </div>
            )}

            {row?.is_blocked && (
              <div
                style={{ cursor: "pointer" }}
                onClick={() => handleUnblockUser(row?.id)}
                title="Débloquer l'utilisateur"
              >
                <FontAwesomeIcon icon={faCheck} color={"#28a745"} />
              </div>
            )}

            {!row?.is_archived && (
              <div
                style={{ cursor: "pointer" }}
                onClick={() => handleArchiveUser(row?.id)}
                title="Archiver l'utilisateur"
              >
                <FontAwesomeIcon icon={faArchive} color={"#6c757d"} />
              </div>
            )}
              */}

            {/* <div
              style={{ cursor: "pointer" }}
              onClick={() => {
                setSelectedId(row?.user);
                setShowDelete(true);
              }}
              title="Supprimer l'utilisateur"
            >
              <FontAwesomeIcon icon={faTrash} color={"#F00"} />
            </div> */}
          </div>
        );
      },
    },
  ];

  return (
    <div className={styles.mainContainer}>
      <AdminHeader />
      <AdminSidebar />

      <DeleteModal
        show={showDelete}
        setter={setShowDelete}
        onClick={() => deleteObj(selectedId)}
      />

      <div className={`${styles.container} me-4`}>
        {/* Ligne des KPIs */}
        {stats && (
          <div className="row">
            <KpiCard
              title="Clients Totaux"
              value={stats.total_clients}
              icon={faUsers}
              color="primary"
            />
            <KpiCard
              title="Clients avec commandes terminées"
              value={stats.active_clients}
              icon={faUserCheck}
              color="success"
            />
            <KpiCard
              title="Nouveaux ce mois-ci"
              value={stats.new_this_month}
              icon={faUserPlus}
              color="info"
            />
            <KpiCard
              title="Nouveaux ce mois-ci qui ont commandé"
              value={stats.new_users_who_ordered}
              icon={faUserTie}
              color="dark"
            />
            <KpiCard
              title="Inactifs (+30j sans commande)"
              value={stats.dormant_clients}
              icon={faClock}
              color="warning"
            />
            <KpiCard
              title="Clients Bloqués"
              value={stats.blocked_clients}
              icon={faUserLock}
              color="danger"
            />
            <KpiCard
              title="Clients Archivés"
              value={stats.archived_clients}
              icon={faBoxArchive}
              color="secondary"
            />
          </div>
        )}

        {/* <TableView
          fetchUrl={"clients"}
          pull={setRows}
          title={"clients"}
          cols={cols}
          rows={rows}
          limit={20}
          noCreate={true}
          useReactQuery={"client-list"}
        /> */}
        <Table
          apiUrl={"clients"}
          queryKey={"client-list"}
          queryOptions={{
            enabled: true,
          }}
          title={"Liste des clients"}
          columns={cols}
          itemsPerPageOptions={[10, 25, 50, 100]}
        />
      </div>
    </div>
  );
}
